// Bu dosya scripts/write-build-version.cjs tarafından üretilir; elle düzenlemeyin.
export const BUILD_VERSION = '202611031654';
